import { render, staticRenderFns } from "./SignalLinkModal.vue?vue&type=template&id=13fed67e&scoped=true&"
import script from "./SignalLinkModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalLinkModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fed67e",
  null
  
)

export default component.exports